import { FiInbox, FiDollarSign, FiGift, FiPackage } from 'react-icons/fi';
import { StatCard, StatCardGrid } from '../../components/common';
import { SUMMARY } from '../../constants/labels';
import { fmtCurrency } from '../../utils/formatNumber';
import { PAYMENT_LABEL } from './receiptsConfig';

export default function ReceiptsSummaryCards({ receipts }) {
  const totalAmount  = receipts.reduce((s, r) => s + parseFloat(r.amountInr || 0), 0);
  const goldCount    = receipts.filter((r) => r.receiptType === 'gold').length;
  const itemCount    = receipts.filter((r) => r.receiptType === 'item').length;

  return (
    <StatCardGrid cols={4}>
      <StatCard
        icon={<FiDollarSign size={18} />}
        iconBg="rgba(16,185,129,0.12)"
        iconColor="#10b981"
        label={SUMMARY.totalReceived}
        value={fmtCurrency(totalAmount)}
        valueColor="green"
      />
      <StatCard
        icon={<FiInbox size={18} />}
        iconBg="rgba(99,102,241,0.12)"
        iconColor="#6366f1"
        label={`${PAYMENT_LABEL.plural} Count`}
        value={String(receipts.length)}
      />
      <StatCard
        icon={<FiGift size={18} />}
        iconBg="rgba(245,158,11,0.12)"
        iconColor="#f59e0b"
        label={SUMMARY.goldDonations}
        value={String(goldCount)}
      />
      <StatCard
        icon={<FiPackage size={18} />}
        iconBg="rgba(14,165,233,0.12)"
        iconColor="#0ea5e9"
        label="Item Donations"
        value={String(itemCount)}
      />
    </StatCardGrid>
  );
}
